import { doc, updateDoc } from 'firebase/firestore';
import { auth, db } from './firebase'

//関数が呼び出された時にポイントを引数に変える
export async function updateTotalPoint(inputTotalPoint) {
  try {
    const userRef = doc(db, 'point', auth.currentUser.uid)

    const data = {
      totalPoint: inputTotalPoint,
    }

    if (data.totalPoint) {
      await updateDoc(userRef, data);
      return "👍 : 正常に変更されました";
    }

  } catch (err) {
    console.error("Error adding document: ", err);
  }
}
